import { AiFillStar } from 'react-icons/ai';

type Props = {
  value: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

export default function NutrientRanking({
  value,
  size = 'md',
  className,
}: Props) {
  return (
    <div
      className={`
      flex 
      shrink-0
      ${size === 'lg' ? 'h-14 w-14' : size === 'md' ? 'h-8 w-8' : 'h-7 w-7'} 
      ${
        value >= 80
          ? 'bg-lime-600'
          : value >= 50
          ? 'bg-lime-700'
          : value < 50
          ? 'bg-lime-800'
          : ''
      } 
      items-center justify-center 
      rounded-md ${className}`}
    >
      <span
        className={`
      ${size === 'lg' ? 'text-3xl' : size === 'md' ? 'text-lg' : 'text-sm'} 
       font-semibold text-white dark:text-gray-100`}
      >
        {value === 100 ? <AiFillStar /> : Math.floor(value ?? 0)}
      </span>
    </div>
  );
}
